export default {"src":"/_next/static/media/logo.b3501226.svg","height":45,"width":40};